/* eslint-disable react-hooks/exhaustive-deps */
import { Icon } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { __ } from "src/libs/utilities"
import { CardFiled, ICard, ICardFieldValue } from "src/modules/pe-landing-module/data/interfaces"
import cardFieldsDefault from "src/modules/pe-landing-module/data/utils/cardFieldsDefault"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import CardFieldContent from "../../contentType/cards/CardFieldContent"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import { defaultSection } from "src/modules/pe-landing-module/data/defaults/defaultSection"


/* Protopia Ecosystem component */
export interface ICardFieldProps {
   data: CardFiled
   cardData: ICard
   value: ICardFieldValue
   i: number
}
const CardField = ({data, ...props}: ICardFieldProps): JSX.Element => {
    const [value, setValue]           = useState<any>( props.value || getCardDefaultValue( data ) )
    useEffect(() => {
        // console.log( props )
        setValue( props.value || getCardDefaultValue( data ) )
    }, [ props, data ])
    
    const onSelect = () => {
        useLandingStore.setState({ selectedCardField: data })
    }

    return <div 
        className='landing-editor-card-field'
        style={{
            height: data.height || data.style?.height
        }}
    >
        <CardFieldContent
            i={props.i}
            field={data as CardFiled} 
            cardData={props.cardData}
            value={value}
            section={ defaultSection() }
        />
        <div className="label pe-surface p-1">
            <div className="pointer">
                { __( components()[ data.type ]?.title || data.type ) }
            </div>
            <Icon icon="eye-on" size={10} className="p-1 hover pointer" />
            <Icon icon="duplicate" size={10} className="p-1 hover pointer" />
            <Icon icon="trash" size={10} className="p-1 hover pointer" />
            <Icon icon="edit" size={10} className="p-1 hover pointer" onClick={onSelect} />
            
        </div>
    </div>
}
export default CardField


export const getCardDefaultValue = ( card_fields:CardFiled ) : any => { 
    const val = cardFieldsDefault()[ card_fields.type ]
    return typeof val !== "undefined" ? val.value : {}  
}